var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-post-mortem"},[_c('h5',[_vm._v(_vm._s(_vm.actionLibelle))]),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.descriptionAction)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }